import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Using the storefront",
    paragraphs: [`Accessing ${STORE.brand} from its ${STORE.operatingRegion} operation means following these site rules. The catalogue, comparison pages, basket and purchase path are provided for genuine personal shopping. Activity that is unlawful, disruptive or harmful to another visitor is outside that permission.`],
  },
  {
    title: "Order details and service messages",
    paragraphs: ["The order path uses an email and delivery form. The person submitting information must be entitled to use it and must keep the delivery facts accurate. Messages about an attempted or accepted order are operational communications, not marketing consent."],
  },
  {
    title: "Permitted access",
    paragraphs: ["Visitors may read product pages and retain policy or order copies for their own shopping records. Permission excludes high-volume extraction that strains the site, checkout circumvention, harmful code, impersonation, payment abuse, catalogue republication and invented endorsement."],
  },
  {
    title: "Availability and external services",
    paragraphs: ["Access may pause for maintenance, defensive work, network outages or circumstances that cannot reasonably be controlled. The hosted checkout and any destination reached by a link operate separately under their own rules. Linking neither makes that material part of this catalogue nor changes who operates it."],
  },
  {
    title: "Product and purchase rules",
    paragraphs: ["Product representations, order formation, totals, cancellations, delivery and remedies are governed by the linked sale and product policies. If a policy and a product page address the same specific fact, the information presented for that selected product or order controls unless it would reduce a mandatory consumer right."],
    links: [["Terms of Sale", "/terms-of-sale"], ["Product Descriptions & Variation", "/product-information"]],
  },
  {
    title: "Mandatory rights and concerns",
    paragraphs: ["Nothing here excludes a liability or remedy that cannot lawfully be excluded. Report a site-access, security or rights concern with the affected page and enough detail to investigate; never include payment-card credentials."],
  },
];

export default function Terms() {
  return <PolicyPage title="Terms of Use" intro="Rules for accessing this catalogue, its content and its purchase path." sections={sections} related={[["Intellectual Property", "/intellectual-property"], ["Accessibility", "/accessibility"], ["Complaints & Policy Updates", "/complaints"]]} />;
}
